module.exports = __webpack_public_path__ + "static/media/menu-enviroment-retail.18e0b9ba.svg";